import dayjs from "dayjs";

const formatDate = (dateString) => {
  // From 2025-10-01T21:27:14.341732Z to 01/10/2025
  if (!dateString) return "";
  return dayjs(dateString).format("DD/MM/YYYY");
};

const formatDateTime = (dateString) => {
  if (!dateString) return "";
  return dayjs(dateString).format("DD/MM/YYYY HH:mm");
};

// The audit-ppp-back SDK reads and writes Date objects, while pinia-orm models and forms keep
// strings: ISO for date-times, YYYY-MM-DD for dates.
const toIsoString = (value) => (value instanceof Date ? value.toISOString() : value);

const toDateString = (value) => (value instanceof Date ? value.toISOString().slice(0, 10) : value);

const toDate = (value) => {
  if (typeof value !== "string") return value;
  return value ? new Date(value) : null;
};

export { formatDate, formatDateTime, toIsoString, toDateString, toDate };
